import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import AlertBody from './components/AlertBody';
import type { AlertBodyTitleColor } from './components/AlertBody';

const yellowIconStyle = {
    backgroundColor: '#FEF3E7',
    border: '2px solid #7A4406',
    color: '#7A4406',
    fontSize: '24px'
};

const redIconStyle = {
    backgroundColor: '#F5577A',
    border: '2px solid #F5577A',
    color: '#F5577A',
    fontSize: '24px'
};

type AlertModalProps = {
    title: string;
    subtext: string;
    icon: string;
    colorType: 'yellow' | 'red';
    handleCloseClick: () => void;
};

const AlertModal: React.FC<AlertModalProps> = ({
    title,
    subtext,
    icon,
    colorType,
    handleCloseClick
}) => (
    <Modal2
        onClose={handleCloseClick}
        additionalStyles={{ iconStyle: colorType === 'yellow' ? yellowIconStyle : redIconStyle }}
        iconName={icon}
        title={title}
    >
        <AlertBody title={title} subtext={subtext} titleColor={colorType as AlertBodyTitleColor} />
    </Modal2>
);

export default AlertModal;